import './App.css';
import logoImg from './assets/serhatLogo.jpeg';

function App() {
  const background = {
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80",
    textColor: '#fff',
    overlay: {
      color: '#000',
      opacity: '.5',
      blur: '3px'
    }
  }
  const logo = {
    src: logoImg,
    alt: 'logo',
    style: {
      width: '200px',
      borderRadius: '50%'

    }
  }
  const description = {
    text1: 'Sitemiz yapım aşamasındadır.',
    text2: 'Yakında hizmetinize sunacağız.',
    style: {
      maxWidth: '440px',
    }
  }

  return (
    <div
      className="UnderConstruction"
      style={{
        backgroundImage: `url(${background.image})`,
        backgroundColor: background.color,
        color: background.textColor,
        ...background.style
      }}
    >
      {background.overlay && background.overlay.color &&
        <div
          style={{
            backgroundColor: background.overlay.opacity
              ? `rgba(0, 0, 0, ${background.overlay.opacity})`
              : background.overlay.color,
            backdropFilter: background.overlay.blur ? `blur(${background.overlay.blur})` : undefined,
            WebkitBackdropFilter: background.overlay.blur ? `blur(${background.overlay.blur})` : undefined,
          }}
          className="UnderConstruction-overlay"
        />}

      <div className="UnderConstruction-container">
        {logo.src &&
          <div className="UnderConstruction-logo-container">
            <img
              className="UnderConstruction-logo"
              alt={logo.alt}
              src={logo.src}
              style={{ ...logo.style }}
            />
          </div>}


        {description.text1 && description.text2 &&
          <div
            className="UnderConstruction-description"
            style={{ ...description.style }}
          >
            {description.text1}
            <br />
            {description.text2}
          </div>}

      </div>
    </div>
  );
}

export default App;

